import { useCallback } from 'react'

import { Ok } from 'ts-results'

import { useApi } from 'app/common/application'

import { FacebookPixelsGetRequest, FacebookPixelsGetResponse } from '../types'

const useFacebookConnectionApi = () => {
  const { create } = useApi()

  const getPixels = useCallback(
    async (adAccountIds: string[]) => {
      const result = await create<FacebookPixelsGetRequest, FacebookPixelsGetResponse>(
        `/connections/facebook/getPixels`,
        { content: { adAccountIds } },
      )
      if (result.ok) {
        return Ok(result.val.data)
      }

      return result
    },
    [create],
  )

  return {
    getPixels,
  }
}

export default useFacebookConnectionApi
